<template>
    <div class="contact-address-wrapper">
        <div v-if="!editMode">
            <div class="row">
                <div class="form-group col-sm-12 col-md-6">
                    <label class="hh-input-label">First name</label>
                    <span class="form-control overflow-x" :class="!userData.firstName ? 'form-color' : ''">
                        {{userData.firstName}}
                    </span>
                </div>
                <div class="form-group col-sm-12 col-md-6">
                    <label class="hh-input-label">Last name</label>
                    <span class="form-control overflow-x" :class="!userData.first_name ? 'form-color' : ''">
                        {{userData.lastName}}
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-12">
                    <label class="hh-input-label">Address Line One</label>
                    <span class="form-control overflow-x" :class="!userData.address1 ? 'form-color' : ''">
                        {{userData.address1}}
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-12">
                    <label class="hh-input-label">Address Line Two</label>
                    <span class="form-control overflow-x" :class="!userData.address2 ? 'form-color' : ''">
                        {{userData.address2}}
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-6">
                    <label class="hh-input-label">City</label>
                    <span class="form-control overflow-x" :class="!userData.city ? 'form-color' : ''">
                        {{userData.city}}
                    </span>
                </div>

                <div class="form-group col-sm-6">
                    <label class="hh-input-label">State</label>
                    <span class="form-control overflow-x" :class="!userData.state ? 'form-color' : ''">
                        {{userData.state}}
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-6">
                    <label class="hh-input-label">Zip code</label>
                    <span class="form-control overflow-x" :class="!userData.zip ? 'form-color' : ''">
                        {{userData.zip}}
                    </span>
                </div>

                <div class="form-group col-sm-6">
                    <label class="hh-input-label">Country</label>
                    <span class="form-control overflow-x" :class="!userData.country ? 'form-color' : ''">
                        {{userData.country}}
                    </span>
                </div>
            </div>
        </div>


        <div v-if="editMode">
            <div class="row">
                <div class="form-group col-sm-6">
                    <input-label type="text" css-class="form-control" v-model="userData.firstName"
                           placeholder="First Name" required/>
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('firstName')">
                            {{errors.get('firstName')}}
                        </div>
                    </div>
                </div>

                <div class="form-group col-sm-6">
                    <input-label type="text" css-class="form-control" v-model="userData.lastName"
                           placeholder="Last Name" required/>
                    <span class="checkmark"></span>
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('lastName')">
                            {{errors.get('lastName')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-12">
                    <input-label type="text" css-class="form-control" v-model="userData.address1"
                           placeholder="Address Line One" required/>
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('address1')">
                            {{errors.get('address1')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-12">
                    <input-label type="text" css-class="form-control" v-model="userData.address2"
                           placeholder="Address Line Two (optional)"/>
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('address2')">
                            {{errors.get('address2')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-6">
                    <input-label type="text" css-class="form-control" v-model="userData.city"
                           placeholder="City" required/>
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('city')">
                            {{errors.get('city')}}
                        </div>
                    </div>
                </div>

                <div class="form-group col-sm-6">
                    <div class="hh-input-label-wrapper">
                     <label class="hh-input-label">State</label>
                        <div class="hh-select" :class="state ? 'hh-input-label-active' : ''">
                            <v-select :options="staticData.states"
                                      :value="state"
                                      @input="setSelected"
                                      required
                                      id="states"
                            />
                        </div>
                       
                    </div>

                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('state')">
                            {{errors.get('state')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-sm-6">
                    <input-label type="text" css-class="form-control" v-model="userData.zip"
                                 placeholder="Zip code" required/>
                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('zip')">
                            {{errors.get('zip')}}
                        </div>
                    </div>
                </div>

                <div class="form-group col-sm-6">
                    <div class="hh-input-label-wrapper">
                     <label class="hh-input-label">Country</label>
                        <div class="hh-select hh-input-label-active">
                            <v-select :options="countries"
                                      v-model="userData.country"
                            />
                        </div>
                    </div>

                    <div>
                        <div class="invalid-feedback-red" v-if="errors.has('country')">
                            {{errors.get('country')}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import vSelect from 'vue-select'
  import InputLabel from './elements/InputLabel'

  export default {
    name: 'Address',

    components: {
      vSelect,
      InputLabel,
    },

    props: {
      userData: {
        firstName: String,
        lastName: String,
        address1: String,
        address2: String,
        country: String,
        city: String,
        state: String,
        zip: String,
      },
      staticData: {
        states: Object,
      },
      editMode: Boolean,
      editInformationRouteName: String,
      errors: Object,
    },

    data: () => {
      return {
        countries: ['United States'],
        state: null,
      }
    },

    beforeMount () {
      this.state = this.userData.state
    },

    mounted () {
      this.$emit('componentLoading', 'ContactInformation', false)
    },

    methods: {
      setSelected(value) {
        this.state = this.userData.state = value
      }
    },

    computed: {

    },
  }
</script>

<style lang="scss" scoped>
    .form-control.overflow-x {
        height: 55px; 
        padding: 12px;
        display: flex;
        align-items: center;
    }
</style>